<div class="form-footer settings-footer">
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-flat-button color="primary" class="next-button" (click)="onNextClick()" [disabled]="isLoading">
            <div class="button-content">
                <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
                <span>{{ buttonText | translate }}</span>
            </div>
        </button>
    </mat-dialog-actions>
</div>
